export { VpHookFormColorInput } from './VpHookFormColorInput';



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpHookFormColorInput/index.js